import { Table } from '@radix-ui/themes';
import { MetricHelper } from 'classes/helpers/metric.helper';
import { DataTableToggler } from 'components/common/training-data-table/toggler';
import { MachineContext } from 'contexts/machine.context';
import { t } from 'i18next';
import { BuildPriority } from 'lib_ts/enums/pitches.enums';
import {
  IBallState,
  ITrajectory,
  ITrajektRefBreak,
} from 'lib_ts/interfaces/pitches';
import { IMachineShot } from 'lib_ts/interfaces/training/i-machine-shot';
import { useContext } from 'react';

export const DataTableHeaderRow = (
  props: {
    priority: BuildPriority;
    targetBS: IBallState;
    targetBreaks?: ITrajektRefBreak;
    targetTraj: ITrajectory;
    actualShots: IMachineShot[];
  } & {
    expanded: boolean;
    onToggle: () => void;
  }
) => {
  const { machine } = useContext(MachineContext);

  const speedUnits = MetricHelper.getSpeedUnit(machine.isMetric);

  switch (props.priority) {
    case BuildPriority.Breaks: {
      const breakUnits = MetricHelper.getBreaksUnit(machine.isMetric);

      return (
        <Table.Row>
          <Table.ColumnHeaderCell>
            <DataTableToggler
              expanded={props.expanded}
              onToggle={props.onToggle}
            />
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell width="32px">
            {/* video playback placeholder */}
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell align="right">
            {t('common.speed')} ({speedUnits})
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell align="right">
            {t('common.vertical-break')} ({breakUnits})
          </Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell align="right">
            {t('common.horizontal-break')} ({breakUnits})
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell width="32px">
            {/* actions placeholder */}
          </Table.ColumnHeaderCell>
        </Table.Row>
      );
    }

    case BuildPriority.Default:
    case BuildPriority.Spins:
    default: {
      return (
        <Table.Row>
          <Table.ColumnHeaderCell>
            <DataTableToggler
              expanded={props.expanded}
              onToggle={props.onToggle}
            />
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell width="32px">
            {/* video playback placeholder */}
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell align="right">
            {t('common.speed')} ({speedUnits})
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell align="right">
            {t('common.spin-x')} (rpm)
          </Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell align="right">
            {t('common.spin-y')} (rpm)
          </Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell align="right">
            {t('common.spin-z')} (rpm)
          </Table.ColumnHeaderCell>

          <Table.ColumnHeaderCell width="32px">
            {/* actions placeholder */}
          </Table.ColumnHeaderCell>
        </Table.Row>
      );
    }
  }
};
